import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ChoiceButton } from "@/components/ChoiceButton";
import { toast } from "sonner";
import { Lock } from "lucide-react";

// "WHICH GROUP IS THE ASSEMBLY'S OWN?" (his call, 3 Nov) — asked once, right where the first child-off starts, never a
// dead end: tap one tag or "None of these", and carry on. The server keeps the same rule (ownTagNeeded mirrors it).
export function ownTagNeeded(part) {
  const nums = part?.numbers || [];
  if (part?.assembly_own_tag || !nums.some((n) => n.group_id)) return false;
  return !nums.some((n) => !n.group_id && n.source === "from_tag");
}

export function boltOnTags(part) {
  const out = [];
  (part?.numbers || []).forEach((n) => {
    if (n.group_id && !out.some((t) => t.id === n.group_id)) out.push({ id: n.group_id, label: n.group_label || "A bolt-on's tag" });
  });
  return out;
}

export function AssemblyOwnChooser({ part, onAnswered, onCancel, testid = "own-tag-ask" }) {
  const [busy, setBusy] = useState(false);
  const answer = async (groupId) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/parts/${part.id}/assembly-own-tag`, { group_id: groupId });
      toast.success(data.message);
      onAnswered?.(groupId);
    } catch (e) {
      // answered a moment ago (another tab, another person): never a dead end — reload and carry on
      if (e.response?.status === 409) { toast.message("It was already answered — carrying on with that answer."); onAnswered?.(undefined); }
      else toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't save the answer.");
    }
    setBusy(false);
  };
  return (
    <div data-testid={testid} className="rounded-xl border-2 border-amber-300 bg-amber-50 p-3 space-y-2">
      <div className="text-sm font-bold text-slate-800 flex items-center gap-1.5"><Lock className="w-4 h-4 text-amber-700" />Which group is the assembly's own?</div>
      <p className="text-[11px] text-slate-600">Asked once for this part. The one you pick stays with the assembly and is never childed off; its loose numbers always stay too.</p>
      <div className="flex flex-wrap gap-1.5">
        {boltOnTags(part).map((t, i) => (
          <ChoiceButton key={t.id} data-testid={`${testid}-pick-${i}`} disabled={busy} onClick={() => answer(t.id)}>{t.label}</ChoiceButton>
        ))}
        <ChoiceButton data-testid={`${testid}-none`} tone="sky" disabled={busy} onClick={() => answer(null)}>None of these</ChoiceButton>
        {onCancel && <ChoiceButton data-testid={`${testid}-cancel`} disabled={busy} onClick={onCancel}>Not now</ChoiceButton>}
      </div>
    </div>
  );
}
